/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sign_In_As_DevInputs */

const th_sign_in_as_dev = /** @type {(inputs: Sign_In_As_DevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เข้าสู่ระบบในนาม (สำหรับนักพัฒนา เฉพาะเครื่องนี้)`)
};

const en_sign_in_as_dev = /** @type {(inputs: Sign_In_As_DevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in as (dev, local only)`)
};

const ja_sign_in_as_dev = /** @type {(inputs: Sign_In_As_DevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`別のユーザーとしてログイン（開発用・ローカル限定）`)
};

const zh_sign_in_as_dev = /** @type {(inputs: Sign_In_As_DevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登录为（开发环境，仅本地）`)
};

const es_sign_in_as_dev = /** @type {(inputs: Sign_In_As_DevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar sesión como (desarrollo, solo local)`)
};

const pt_sign_in_as_dev = /** @type {(inputs: Sign_In_As_DevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrar como (desenvolvimento, apenas local)`)
};

const id_sign_in_as_dev = /** @type {(inputs: Sign_In_As_DevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masuk sebagai (pengembangan, lokal saja)`)
};

const fr_sign_in_as_dev = /** @type {(inputs: Sign_In_As_DevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se connecter en tant que (développement, local uniquement)`)
};

const tl_sign_in_as_dev = /** @type {(inputs: Sign_In_As_DevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mag-sign in bilang (development, lokal lamang)`)
};

const vi_sign_in_as_dev = /** @type {(inputs: Sign_In_As_DevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đăng nhập với tư cách (phát triển, chỉ nội bộ)`)
};

const ko_sign_in_as_dev = /** @type {(inputs: Sign_In_As_DevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`다음 계정으로 로그인 (개발용, 로컬 전용)`)
};

const de_sign_in_as_dev = /** @type {(inputs: Sign_In_As_DevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmelden als (Entwicklung, nur lokal)`)
};

const ru_sign_in_as_dev = /** @type {(inputs: Sign_In_As_DevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Войти как (разработка, только локально)`)
};

const tr_sign_in_as_dev = /** @type {(inputs: Sign_In_As_DevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Şu kişi olarak giriş yap (geliştirme, yalnızca yerel)`)
};

const it_sign_in_as_dev = /** @type {(inputs: Sign_In_As_DevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accedi come (sviluppo, solo in locale)`)
};

const pl_sign_in_as_dev = /** @type {(inputs: Sign_In_As_DevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaloguj się jako (wersja deweloperska, tylko lokalnie)`)
};

const uk_sign_in_as_dev = /** @type {(inputs: Sign_In_As_DevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Увійти як (розробка, лише локально)`)
};

const hi_sign_in_as_dev = /** @type {(inputs: Sign_In_As_DevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस रूप में साइन इन करें (डेवलपमेंट, केवल स्थानीय)`)
};

const ar_sign_in_as_dev = /** @type {(inputs: Sign_In_As_DevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سجّل الدخول بصفة (تطوير، محلي فقط)`)
};

const ms_sign_in_as_dev = /** @type {(inputs: Sign_In_As_DevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log masuk sebagai (pembangunan, setempat sahaja)`)
};

const bn_sign_in_as_dev = /** @type {(inputs: Sign_In_As_DevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এই পরিচয়ে সাইন ইন (ডেভেলপমেন্ট, শুধু স্থানীয়)`)
};

const zh_tw2_sign_in_as_dev = /** @type {(inputs: Sign_In_As_DevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`以此身分登入（開發環境，僅限本機）`)
};

const zh_hk2_sign_in_as_dev = /** @type {(inputs: Sign_In_As_DevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`以此身分登入（開發環境，僅限本機）`)
};

const ur_sign_in_as_dev = /** @type {(inputs: Sign_In_As_DevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اس حیثیت سے سائن اِن (ڈویلپمنٹ، صرف مقامی)`)
};

const fa_sign_in_as_dev = /** @type {(inputs: Sign_In_As_DevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ورود به نام (توسعه، فقط محلی)`)
};

const sw_sign_in_as_dev = /** @type {(inputs: Sign_In_As_DevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingia kama (uendelezaji, ndani pekee)`)
};

const nl_sign_in_as_dev = /** @type {(inputs: Sign_In_As_DevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inloggen als (ontwikkeling, alleen lokaal)`)
};

/**
* | output |
* | --- |
* | "Sign in as (dev, local only)" |
*
* @param {Sign_In_As_DevInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const sign_in_as_dev = /** @type {((inputs?: Sign_In_As_DevInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sign_In_As_DevInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_sign_in_as_dev(inputs)
	if (locale === "ja") return ja_sign_in_as_dev(inputs)
	if (locale === "zh") return zh_sign_in_as_dev(inputs)
	if (locale === "es") return es_sign_in_as_dev(inputs)
	if (locale === "pt") return pt_sign_in_as_dev(inputs)
	if (locale === "id") return id_sign_in_as_dev(inputs)
	if (locale === "fr") return fr_sign_in_as_dev(inputs)
	if (locale === "tl") return tl_sign_in_as_dev(inputs)
	if (locale === "vi") return vi_sign_in_as_dev(inputs)
	if (locale === "ko") return ko_sign_in_as_dev(inputs)
	if (locale === "de") return de_sign_in_as_dev(inputs)
	if (locale === "ru") return ru_sign_in_as_dev(inputs)
	if (locale === "tr") return tr_sign_in_as_dev(inputs)
	if (locale === "it") return it_sign_in_as_dev(inputs)
	if (locale === "pl") return pl_sign_in_as_dev(inputs)
	if (locale === "uk") return uk_sign_in_as_dev(inputs)
	if (locale === "hi") return hi_sign_in_as_dev(inputs)
	if (locale === "ar") return ar_sign_in_as_dev(inputs)
	if (locale === "ms") return ms_sign_in_as_dev(inputs)
	if (locale === "bn") return bn_sign_in_as_dev(inputs)
	if (locale === "zh-TW") return zh_tw2_sign_in_as_dev(inputs)
	if (locale === "zh-HK") return zh_hk2_sign_in_as_dev(inputs)
	if (locale === "ur") return ur_sign_in_as_dev(inputs)
	if (locale === "fa") return fa_sign_in_as_dev(inputs)
	if (locale === "sw") return sw_sign_in_as_dev(inputs)
	if (locale === "nl") return nl_sign_in_as_dev(inputs)
	return en_sign_in_as_dev(inputs)
});